import { TenantedClientApplicationManagedByChoices } from "@graphql/generated/graphql.g";

import { Tag } from "@design-system/Tag/Tag";

type Props = {
  text?: TenantedClientApplicationManagedByChoices | null;
};

export const ManagedByTag = ({ text }: Props) => {
  if (!text) {
    return null;
  }

  const colorMap: Record<
    TenantedClientApplicationManagedByChoices,
    "danger" | "secondary" | "success" | "warning"
  > = {
    [TenantedClientApplicationManagedByChoices.Msp]: "success",
    [TenantedClientApplicationManagedByChoices.Client]: "warning",
    [TenantedClientApplicationManagedByChoices.Vendor]: "secondary",
  };

  return <Tag color={colorMap[text]} text={text} />;
};
